import { createAction, handleAggregatorResponse } from '@wix/communities-blog-client-common';

export const CATEGORY_MENU_WIDGET_SUCCESS = 'categoryMenuWidget/SUCCESS';

const categoryMenuWidgetSuccess = createAction(CATEGORY_MENU_WIDGET_SUCCESS);
const categoryMenuWidgetFailure = createAction('categoryMenuWidget/FAILURE');

const createCategoryMenuWidget =
  (action: any) =>
  (...args: any[]) =>
  (dispatch: any) => {
    return dispatch(action(...args))
      .then((categoryMenu: any) => dispatch(categoryMenuWidgetSuccess(categoryMenu)))
      .catch(() => dispatch(categoryMenuWidgetFailure()));
  };

export const handleCategoryMenuWidgetResponse = createCategoryMenuWidget(handleAggregatorResponse);
